exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.paySchedule[data-v-6742d4e2]{width:100%;border-collapse:collapse}.paySchedule td[data-v-6742d4e2],.paySchedule th[data-v-6742d4e2]{border:1px solid #ccc;text-align:center;padding:0}.paySchedule td[data-v-6742d4e2]{line-height:33px}.paySchedule tr.tb-td td[data-v-6742d4e2]{font-weight:700}td.textCenter[data-v-6742d4e2]{text-align:center}td.textRight[data-v-6742d4e2]{text-align:right}td input[data-v-6742d4e2]{width:100%;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6742d4e2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lending/installmentCollection/RePayment.vue
// module id = 1591
// module chunks = 3